import React, {ReactNode} from "react";
import {get} from 'lodash';
import {IUsefulLink, UsefulLinkRenderOptions} from "./useful-link.interface";
import {IUsefulLinkConfiguration} from "../../configurations/config-data-sections/drawer.configuration";
import {IServiceFactory} from "../../service-factory.interface";
import {UsefulLinksItemBox} from '../../../components/useful-links/boxes/useful-links-item/useful-links-item.box';
import {Image} from "../../../components/raw-components/image/image";

type LinkActionType = (config: IUsefulLinkConfiguration) => void;

export class ConfigUsefulLink implements IUsefulLink {
  private readonly linkConfig: IUsefulLinkConfiguration;
  private readonly linkAction: LinkActionType;
  private readonly services: IServiceFactory;

  constructor(linkConfig: IUsefulLinkConfiguration, linkAction: LinkActionType, services: IServiceFactory){
    this.linkConfig = linkConfig;
    this.linkAction = linkAction;
    this.services = services;
  }

  private renderTextItem(options: UsefulLinkRenderOptions): ReactNode {
        const {id, text, iconAsset} = this.linkConfig;
        const iconURI = get(this.services.theme.currentTheme.images, iconAsset, null);

        return (
          <UsefulLinksItemBox key={id} className='cy-useful-links-item'
                              icon={iconURI}
                              onClick={() => {
                                  if(options.onClick) {
                                      options.onClick();
                                  }
                                  this.linkAction(this.linkConfig);
                              }}>
              {this.services.translation.translate(text)}
          </UsefulLinksItemBox>
        );
  }

    private renderImageItem(options: UsefulLinkRenderOptions): ReactNode {
        const {id, imageAsset, imageAlt} = this.linkConfig;
        const imageURI = get(this.services.theme.currentTheme.images, imageAsset, '');

        return (
            <UsefulLinksItemBox key={id} hideArrow={true} className='cy-useful-links-item'
                                onClick={() => {
                                    if(options.onClick) {
                                        options.onClick();
                                    }
                                    this.linkAction(this.linkConfig);
                                }}>
                <Image src={imageURI} alt={imageAlt || ''} />
            </UsefulLinksItemBox>
        );
    }

  render(options: UsefulLinkRenderOptions): ReactNode {
    if(!this.linkConfig.display) return null;

    return this.linkConfig.imageAsset ? this.renderImageItem(options) : this.renderTextItem(options);
  }
}
